import { render, staticRenderFns } from "./UserAvatarWithName.vue?vue&type=template&id=237b3fb4&scoped=true&"
import script from "./UserAvatarWithName.vue?vue&type=script&lang=js&"
export * from "./UserAvatarWithName.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarWithName.vue?vue&type=style&index=0&id=237b3fb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237b3fb4",
  null
  
)

export default component.exports